import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./index.scss";

const ProductCard = ({ name, description, imageSource, comingSoon, link }) => {
  return (
    <Link className={`product-card ${comingSoon ? "-soon" : ""}`} to={link}>
      <div className="image-wrapper">
        <img className="image" alt="product" src={imageSource} />
      </div>
      <p className="product-name">
        {name} {comingSoon && <div className="tag">Coming Soon</div>}
      </p>
      <p className="product-details">{description}</p>
    </Link>
  );
};

ProductCard.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageSource: PropTypes.string.isRequired,
  comingSoon: PropTypes.bool,
  link: PropTypes.string,
};

ProductCard.defaultProps = {
  comingSoon: false,
  link: "/products-and-guides",
};

export default ProductCard;
